import { render, staticRenderFns } from "./registerWorks.vue?vue&type=template&id=460847b7&scoped=true"
import script from "./registerWorks.vue?vue&type=script&lang=js"
export * from "./registerWorks.vue?vue&type=script&lang=js"
import style0 from "./registerWorks.vue?vue&type=style&index=0&id=460847b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460847b7",
  null
  
)

export default component.exports